//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength, integer } from "vuelidate/lib/validators";
import { UserMixin } from "~/node_modules/sitis-nuxt/lib/mixins";

export default {

  data: function () {
    return {
      form: {
        name: "",
        phone: "",
        message: "",
      },

      isLoading: false
    }
  },

  props: {
    title: {
      type: String,
      default: "Обратный звонок"
    },
    type: {
      type: String,
      default: "Обратный звонок"
    },
    closeNotification: {
      type: String,
      default: "Обратный звонок"
    },
  },

  mixins: [ UserMixin ],

  validations: {
    form: {
      name: { required, minLength: minLength(2) },
      phone: { required, minLength: minLength(18) }
    },
  },

  mounted() {
    this.$modal.show("callback-modal");

    this.initForm();
  },

  methods: {

    initForm: function() {
      if (!this.user) {
        return null
      }

      this.form.name = this.user?.name || "";

      let phone = ('' + this.user?.phone).replace(/\D/g, '').substr(1);
      let phoneMatch = phone.match(/^(\d{3})(\d{2})(\d{2})(\d{3})$/);
      this.form.phone = Boolean(this.user?.phone) ? `(${phoneMatch[1]}) ${phoneMatch[2]}-${phoneMatch[3]}-${phoneMatch[4]}` : "";
    },

    sendForm: async function() {

      this.$v.$touch();

      if (this.$v.$invalid) {

        this.$customNotification.error("Проверьте корректность заполненных данных")

        return null
      }

      this.isLoading = true;

      const body = {
        type: this.type,
        name: this.form.name,
        phone: (this.form.phone || '').replace(/\D+/g,""),
        message: this.form.message
      };

      const { data } = await this.$api.agent.transport.post("form/send", body);

      this.isLoading = false;

      if (this.closeNotification) {
        this.$toast.success(this.closeNotification);
        this.$emit("close");
        return
      }

      this.$router.push("/zapis/success");
    }

  }

};
